export const mainBoxStyle = {
  height: '60vh',
  gap: '40px',
  display: 'flex',
}

export const modalColumnHeadingBox = {
  display: 'flex',
  width: '27vw',
  flexDirection: 'column',
  gap: '15px',
}

export const controllerBox = {
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  paddingTop: '5px',
  overflow: 'auto',
}

export const closeButtonStyle = {}

export const errorMessageStyle = {
  color: '#db3b3b',
}
